import pokemonsFile from '../constants/pokemons.json'

const NO_POKEMON = 'N/A'

interface Pokemon {
  number: number
  name: string
}

export const getTJPokemon = (tj: number): string => {
  const { pokemons }: { pokemons: Pokemon[] } = pokemonsFile

  if (tj > 151) {
    tj -= 151
  }

  if (tj < 152 && tj > 0) {
    const pokemon = pokemons[tj - 1]
    return pokemon.name
  }

  return NO_POKEMON
}
